import { BannerArrow } from '../BannerArrow/BannerArrow'
import styles from './ChildrenBanner.module.css'
import imageBunner from './ChildrenBunnerImage.png'
export const ChildrenBanner = () =>{
    const contentCard = <div>
        Мы получили подарки и очень обрадовались — дети в восторге, а для нас очень ценно ваше внимание и забота. Сейчас в нашем учреждении живут 40 детей. 
        <br></br><br></br>
        Уже 30 лет у нас существует добрая традиция — праздник урожая. Это кульминация всего летнего сезона, когда ребята с гордостью показывают результаты своего труда и готовят праздничный концерт. В этом году ваши подарки станут для них особенной наградой — мы вручим их как призы за старание и отличную работу на грядках.
        <br></br><br></br>
        Спасибо, что помогаете нам делать этот праздник еще ярче и радостнее для детей. Ваша поддержка очень важна для нас!

    </div>
    return(
        <div className={styles.children_banner_container}>
            <img src={imageBunner} style={{width:"100%"}}/>
            <div className={styles.children_banner_titile}>
                Всей команде Сбербанка огромное спасибо за чудесные подарки! 
                С искренней благодарностью, коллектив и воспитанники учреждения ГУСО "Хохотуйский центр помощи детям, оставшимся без попечения родителей "Берёзка":
            </div>
            <BannerArrow children={contentCard}/>

        </div>
    )
}